import axios from "../axios/AxiosInstance";

const URL = "user/me/commercial-state";
const legacyKey = () =>
  `jm-commercial-live:${localStorage.getItem("userId")}:${localStorage.getItem("agencyName")}`;

// Reprend l'état enregistré dans le navigateur par les versions précédentes, une seule fois.
function readLegacyState() {
  try {
    const saved = JSON.parse(localStorage.getItem(legacyKey()));
    return saved && typeof saved === "object" ? saved : null;
  } catch {
    return null;
  }
}

export async function loadCommercialState() {
  const { data } = await axios.get(URL);
  if (data?.state) return data.state;
  const legacy = readLegacyState();
  if (legacy) {
    await axios.put(URL, { state: legacy });
    try { localStorage.removeItem(legacyKey()); } catch { /* Stockage indisponible. */ }
  }
  return legacy;
}

let timer = null;
let pending = null;
let waiting = [];
let requestQueue = Promise.resolve();

function sendPending() {
  if (!pending) return;
  const body = pending;
  const callers = waiting;
  pending = null;
  waiting = [];
  timer = null;

  // Les requêtes restent ordonnées : une ancienne sauvegarde lente ne peut
  // pas écraser un résultat d'appel plus récent.
  requestQueue = requestQueue
    .catch(() => {})
    .then(async () => {
      // The API list is authoritative: old imported snapshots can belong to a
      // different agency. Keep synthetic local prospects, never reassign clients.
      const { data: clients } = await axios.get("client/freelance");
      if (!Array.isArray(clients)) throw new Error("Portefeuille serveur indisponible.");
      const allowed = new Set(clients.map(client => String(client._id || client.id)));
      const currentClients = [], archivedClients = [...(body.archivedClients || [])];
      for (const client of body.clients || []) {
        const id = String(client.client_id || client.establishment_id || client.id);
        if (!/^[a-f0-9]{24}$/i.test(id) || allowed.has(id)) currentClients.push(client);
        else archivedClients.push(client);
      }
      const scoped = { ...body, clients: currentClients, archivedClients };
      return axios.put(URL, { state: scoped });
    });
  requestQueue.then(
    (result) => callers.forEach((caller) => caller.resolve(result)),
    (error) => callers.forEach((caller) => caller.reject(error)),
  );
}

// Regroupe les sauvegardes rapprochées ; toutes les promesses en attente suivent le dernier envoi.
export function saveCommercialState(state, delay = 1500) {
  pending = state;
  clearTimeout(timer);
  return new Promise((resolve, reject) => {
    waiting.push({ resolve, reject });
    if (delay <= 0) sendPending();
    else timer = setTimeout(sendPending, delay);
  });
}
